import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePickercom from '../components/Datepickercom'; 
import {ReactComponent as Logo} from '../assets/Group 2.svg';
import { ReactComponent as Coct } from '../assets/s-cockt.svg';
import { ReactComponent as Coll} from "../assets/s-col.svg";
import { ReactComponent as Co} from "../assets/s-cost.svg";
import { ReactComponent as Prop} from "../assets/s-prof.svg"
import { ReactComponent as More} from "../assets/s-more.svg";
import { ReactComponent as DailyIcon} from "../assets/daily-icon.svg";
import { ReactComponent as MonthlyIcon} from "../assets/mont-icon.svg";
import {ReactComponent as SubIcon} from '../assets/subtract.svg';
import IngredientTable from "../components/IngredientTable";
import SideBar from "../components/SideBar";
import RecipesTable from "../components/RecipesTable";
import PumpsTable from "../components/PumpsTable";
import HomeIngredient from "../components/HomeIngredient";
import CleaningTable from "../components/CleaningTable";
import Navbar from '../components/Navbar';
import Configurations from '../components/Configurations';
import moment from 'moment';
import axios from 'axios';
                //    smallMedia imports
import SIngreH from "../components/smallMedia/ShomeIngredients";
import Sclean from "../components/smallMedia/Scleaning";
import MntlySlsDtls from '../components/MntlySlsDtls';
import { useNavigate } from 'react-router-dom';


// pageicons
import dbIcon from "../assets/home-white.svg";
import ingredientIcon from "../assets/ingredient-white.svg";
import recipesIcon from "../assets/recipe-white.svg";
import pumpsIcon from "../assets/pumps-white.svg";
import reportsIcon from "../assets/reports-white.svg";
import configurationIcon from "../assets/config.svg";

import "../App.css";

const DashBoard = () =>{
    const navigate = useNavigate();
    const [pageName, setPageName] = useState("Dashboard");
    const [cocktails, setCocktails] = useState(0);
    const [collections, setCollections] = useState(0);
    const [cost, setCost] = useState(0);
    const [profit, setProfit] = useState(0);
    const [startSession, setStartSession] = useState(false);
    const [home, setHome] = useState(true);
    const [ingredient, setIngredient] = useState(false);
    const [recipe, setRecipe] = useState(false);
    const [pumps, setPumps] = useState(false);
    const [report, setReport] = useState(false);
    const [configuration, setconfuguration] = useState(false);
    const [pageIcon, setPageIcon] = useState(dbIcon);
    const [showDiv, setShowDiv] = useState(false);
    const [uName, setUName] = useState("");
    const [uId , setUId] = useState("");
    const [uImg, setUImg] = useState("");
    const [uMmbr, setUMmbr] = useState("");
    const [uPassword , setUPassword] = useState("");
    const [uRole , setURole] = useState("");
    const [uJoinD , setUJoinD] = useState("");
    const [uEmail , setUEmail] = useState("");
    const [adminU, setAdminU] = useState(""); 
    const [ulog, setUlog] = useState(false);
    // const [user_id, setUser_id] = useState(2);
    const [userD, setUserD] = useState(null);
                // newtask
    const [selMIds, setSelMids] = useState([]);
    const [cssLoaded, setCssLoaded] = useState(false);
    const [mntlyRecSls, setMntlyRecSls] = useState(false);
    const childRef = useRef();
    const [dlySls, setDlySls] = useState(false)
                // newtask

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [classWidth, setClassWidth] = useState(0);
    const [classHeight, setClassHeight] = useState(0);
    const [currencyDash, setCurrencyDash] = useState("");
//   Function to detect client screen w * h
    useEffect(() => {
        
      const updateDimensions = () => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        setWidth(newWidth);
        setHeight(newHeight);
        const newClassWidth = newWidth;
        const newClassHeight = newClassWidth * 0.75;
        setClassHeight(newClassHeight);
        setClassWidth(newClassWidth);
      };
  
      // Add event listener for resize event
      window.addEventListener('resize', updateDimensions);
  
      // Initial log
      updateDimensions();
  
      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('resize', updateDimensions);
      };
    }, []);

useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');

    if (!userDataString) {
        // If session data is not found
        navigate('/');
        return;
    }

    const userData = JSON.parse(userDataString);

    // Check if selectedMachineIds is missing or empty
    if (!userData.selectedMachineIds || userData.selectedMachineIds.length === 0) {
        alert('You did not select any machine. Please select a machine.');
        navigate('/details');
    }
}, [navigate]);

// Get user data from session storage
useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserD(userData);
        // Use userData as needed
    }
    // console.log(userDataString);
}, []);
    useEffect(() => {
        
        setUId(userD?.id); 
        setUName(userD?.name);
        setSelMids(userD?.selectedMachineIds);
        const userDate = userD ?.datetime;
        const spltD = userDate ?.split("T")[0];
        setUMmbr(spltD);
        const defImg = require(`../components/img/images/user.png`);
        if (userD?.u_img) {
            try {
              // Try to import the image dynamically
              const image = require(`../..//img/userimages/${userD.u_img}`);
              
              setUImg(image);
            } catch (error) {
              // If image is not found, use default image
              console.error("Image not found:", error);
              setUImg(defImg);
            }
          } else {
            setUImg(defImg);
          }
    }, [userD]);
    const handlePageNameChange = (newPageName) => {
        setPageName(newPageName);
      };
    const handleHomeClick = () => {
        localStorage.setItem("activeTab", "home");
        setPageName("Dashboard");
        setPageIcon(dbIcon);
        setHome(true);
        setIngredient(false);
        setRecipe(false);
        setPumps(false);
        setReport(false);
        setconfuguration(false);
    };

    const handleIngredientsClick = () => {
        localStorage.setItem("activeTab", "ingredient");
        setPageName("Ingredients");
        setPageIcon(ingredientIcon);
        setHome(false);
        setIngredient(true);
        setRecipe(false);
        setPumps(false);
        setReport(false);
        setconfuguration(false);
    };

    const handleRecipesClick = () => {
        localStorage.setItem("activeTab", "recipe");
        setPageName("Recipes");
        setPageIcon(recipesIcon);
        setHome(false);
        setIngredient(false);
        setRecipe(true);
        setPumps(false);
        setReport(false);
        setconfuguration(false);
        if (childRef.current) {
            childRef.current.fetchPumps();
            childRef.current.fetchRecipes();
            childRef.current.fetchIngredients();
        }
    };

    const handlePumpsClick = () => {
        localStorage.setItem("activeTab", "pumps");
        setPageName("Pumps");
        setPageIcon(pumpsIcon);
        setHome(false);
        setIngredient(false);
        setRecipe(false);
        setPumps(true);
        setReport(false);
        setconfuguration(false);
    };

    const handleReportsClick = () => {
        localStorage.setItem("activeTab", "report");
        setPageName("Reports");
        setPageIcon(reportsIcon);
        setHome(false);
        setIngredient(false);
        setRecipe(false);
        setPumps(false);
        setReport(true);
        setconfuguration(false);
    };

    const handleConfigurationsClick = () => {
        localStorage.setItem("activeTab", "configuration");
        setPageName("Configuration");
        setPageIcon(configurationIcon);
        setHome(false);
        setIngredient(false);
        setRecipe(false);
        setPumps(false);
        setReport(false);
        setconfuguration(true);
    };

    useEffect(() => {

    const activeTab = localStorage.getItem("activeTab");
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });

        switch (activeTab) {
            case "recipe":
                handleRecipesClick();
                break;

            case "ingredient":
                handleIngredientsClick();
                break;

            case "pumps":
                handlePumpsClick();
                break;

            case "report":
                handleReportsClick();
                break;

            case "configuration":
                handleConfigurationsClick();
                break;

            default:
                handleHomeClick();
        }
    }, []);
    const setDisplay = () => {
        setShowDiv(!showDiv)
    }

    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed


    useEffect(() => {
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, [smallMedia]);

    useEffect(() => {
        currentReport();
      }, [uId]);
    useEffect(() => {
        // Function to fetch current report
        const fetchCurrentReport = () => {
                // console.log("check time");
          currentReport();
        };
        // fetchCurrentReport();
        const intervalId = setInterval(fetchCurrentReport, 15000);
        return () => clearInterval(intervalId);
      }, [uId]);
    const currentReport = () =>{
        const currentDate = new Date();
        const firstDayCurrentM = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth()
        );

        const from = moment(firstDayCurrentM)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

        const to = moment(currentDate)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
       const userId = uId;
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        if (!userData || !userData.id) {
        throw new Error('User ID not found in session storage');
        }
        const userId2 = userData.id;
        const macId2 = userData.selectedMachineIds;
        const dataToSend = {
          from: from,
          to: to,
          user_id : userId2,
          machinesIds : macId2
        };
        // console.log(dataToSend);
        
          const fetchData = async () => {
            try {
              const response = await axios.post(
                    '/api/current-reports',
                    dataToSend,
                    {
                    withCredentials: true, // ✅ ensures cookies are sent
                    }
                );
              const data = response.data;
              // console.log('Response data:', data);
        
              if (data) {
                setCocktails(data.cocktails);
                setCost(data.COST);
                setProfit(data.PROFIT);
                setCollections(data.collections);
              } else {
                alert('Response data is undefined');
              }
            } catch (error) {
              console.error('Error fetching reports:', error);
              // Handle error
            }
          };
        
          fetchData(); 
              
    } 
    const logoutfnc = () =>{
        setUlog(!ulog);
    }
    const signOutFunc = async () => {
      try {
        await axios.post("/api/logout", {}, { withCredentials: true });
        sessionStorage.removeItem('userData');
        navigate('/'); 
        window.location.reload();
      } catch (error) {
        console.error("Error logging out:", error.response?.data || error.message);
      }
    };
    const showDlyRev = () =>{
        setMntlyRecSls(false);
        setDlySls(true);
    }
    const showMntlySlsRec = () =>{
        // alert("monthly details recipes clicked");
        setMntlyRecSls(true);
        setDlySls(false);
    }
  const [data, setData] = useState([]);
  const [dataDly, setDataDly] = useState([]);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [range, setRange] = useState("week");
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch data from backend
  const fetchSalesData = async (selectedRange = "week") => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (!userData || !userData.id) {
      console.error("User not found");
      return;
    }

    const userId = userData.id;
    const machineId = userData.selectedMachineIds[0];

    try {
      setLoading(true);
      const res = await axios.get("/api/sales-summary-grapgh", {
        params: {
          userId,
          machineId,
          range: selectedRange
        },
        withCredentials: true
      });

    //   setData(res.data);
// console.log(res.data, "monthly revenue");

        setData(
        res.data.filter(item => item.name && item.revenue)
        );
    } catch (err) {
      console.error(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

    const fetchSalesDataDaily = async (selectedRange = "week") => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (!userData || !userData.id) {
      console.error("User not found");
      return;
    }

    const userId = userData.id;
    const machineId = userData.selectedMachineIds[0];

    try {
      setLoading(true);
      const res = await axios.get("/api/sales-summary-grapgh", {
        params: {
          userId,
          machineId,
          range: selectedRange
        },
        withCredentials: true
      });

    //   setData(res.data);
// console.log(res.data, "from daily graph");

        setDataDly(
        res.data.filter(item => item.name && item.revenue)
        );
    } catch (err) {
      console.error(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Load default (monthly)
  useEffect(() => {
    fetchSalesData("month");
    fetchSalesDataDaily("day");
  }, []);
  const margin =
  cost > 0
    ? (((collections - cost) / cost) * 100).toFixed(2)
    : "0.00";
    return (
        <>
        {smallMedia ? (
            <div className="dashboardFS">
            <div className='navbar'>
            <Navbar 
                onHomeClick={handleHomeClick} 
                onIngredientsClick={handleIngredientsClick} 
                onRecipesClick={handleRecipesClick} 
                onPumpsClick={handlePumpsClick} 
                onReportsClick={handleReportsClick} 
                onConfigurationsClick={handleConfigurationsClick}
            />
                </div>
            <div className="group2-s" style={{display: 'none'}}>
                <div className='smCnts-s'> 
                               {/* 1st container */}
                <div className={`small-contair-s ${smallMedia ? "small-contairsm" : ""}`}>
                <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
                <div className='cntr-txt'>
                {cocktails != null ? cocktails : 0 }
                </div>
                </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Coct className='sp-icon'/>
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cocktail</div>
                    </div>
                </div>
                <div className='empty-div'>
                    <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                            <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                            <button className='trans'>
                                <p className="btnTxt">More info</p>
                                <div className="btn-vec">
                                    <More className='vctr'/>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
                               {/* 2nd container */}
                                          
            <div className={`small-contair-s ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt'>
            {currencyDash}{cost != null ? cost : 0}
            </div>
            </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                  
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Co className="sp-icon" />
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
                    </div>
                </div>
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More  className='vctr' />
                </div>
                </button>
                </div>
                </div>
                </div>
            </div>
                               {/* 3rd container */}
                                   
            <div className={`small-contair-s ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t sm-co-t-sp ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt cntr-txt-sp'>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Profit</div><div>{currencyDash} {profit != null ? profit.toFixed(2) : "0.00"}</div> 
                </div>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Margin</div><div>{margin}%</div> 
                </div>  
            </div>
            </div>
                {/* <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                  
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Co className="sp-icon" />
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
                    </div>
                </div>  */}
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More className='vctr'/>
                </div>
                </button>
                </div>
            </div>
            </div>
            </div>
                               {/* 4th container */}
                                     
            <div className={`small-contair-s ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt'>
            {currencyDash}{collections != null ? collections.toFixed(2) : 0}
            </div>
            </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Coll className='sp-icon'/>
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`} >Collection</div>
                    </div>
                </div>
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More className='vctr'/>
                </div>
                </button>
                </div>
                </div>
                </div>
            </div>
            </div>
            <div className='group2b-s'>
                <div  className="daily-div daily-diva-s">
                <div className="triangle-container-dr" >
                <div className="shadeTriangle-dr2"></div>
                </div>
                <div className='overly-fix' onClick={showDlyRev}></div>
                <div className='bDaily mont-sls-cont'>
                <div className='bDaily-hdng'>
                    <div className="dr-icon">
                        <DailyIcon className="icon-sm"/>
                    </div>
                    <div className="dr-t dr-t2">
                        Daily Revenue
                    </div>
                </div>
                </div>
                    <div className="daily-r" style={{width: '100%'}}>
                    <div className={`monthly-s ${smallMedia ? 'monthly-s2' : ''}`} >
                        <div className='mntly-dtls-sls-dsh'>
                            <table className='mntlyTblDtlsDsh'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Sale Count</th>
                                        <th>Revenue</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...dataDly]
                                    .sort((a, b) => Number(b.revenue || 0) - Number(a.revenue || 0))
                                    .map((item, index) => (
                                        <tr key={index}>
                                        <td title={item.name || "N/A"}>
                                            {item.name
                                            ? item.name.length > 15
                                                ? `${item.name.slice(0, 15)}...`
                                                : item.name
                                            : "N/A"}
                                        </td>

                                        <td>{item.sales ? item.sales : "N/A"}</td>

                                        <td>{item.revenue ? item.revenue : "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
                </div>
                <div className="daily-div daily-diva-s">
                <div className="triangle-container-dr" >
                <div className="shadeTriangle-dr2"></div>
                </div>
                <div className='overly-fix' onClick={showMntlySlsRec}></div>
                <div className='bDaily mont-sls-cont'>
                <div className='bDaily-hdng'>
                <div className="mo-s">
                    <MonthlyIcon className="icon-sm" />
                </div>
                <div className={`mo-t ${smallMedia ? "mo-t2" : ""}`}>
                    Monthly Sales of Recipe
                </div>
                </div>
                </div>
                    <div className={`monthly-s ${smallMedia ? 'monthly-s2' : ''}`} >
                        <div className='mntly-dtls-sls-dsh'>
                            <table className='mntlyTblDtlsDsh'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Sale Count</th>
                                        <th>Revenue</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...data]
                                    .sort((a, b) => Number(b.revenue || 0) - Number(a.revenue || 0))
                                    .map((item, index) => (
                                        <tr key={index}>
                                        <td title={item.name || "N/A"}>
                                            {item.name
                                            ? item.name.length > 15
                                                ? `${item.name.slice(0, 15)}...`
                                                : item.name
                                            : "N/A"}
                                        </td>

                                        <td>{item.sales ? item.sales : "N/A"}</td>

                                        <td>{item.revenue ? item.revenue : "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </div>
            <div className='d-table-s'>
            <div  className="stock-con font-sm" >
                <SIngreH uId={uId}/>
            </div>
            <div style={{display: smallMedia ? "block" : "none"}} className='empty-tbl'></div>
            <div  className={`cl-con ${smallMedia ? "mrgnR" : "monthlyDiv"}`}>
            <Sclean uId={uId}/>
            </div>
        </div>
        </div>

        </div>) : (
        <div className="dashboardF" style={{height: `${classHeight}px`,width: `${classWidth}px`}}>
            <div className='navbar' style={{display: smallMedia ? "block" : "none"}}>
            <Navbar 
                    onHomeClick={handleHomeClick} 
                    onIngredientsClick={handleIngredientsClick} 
                    onRecipesClick={handleRecipesClick} 
                    onPumpsClick={handlePumpsClick} 
                    onReportsClick={handleReportsClick} 
                    onConfigurationsClick={handleConfigurationsClick}
                />
                </div>
                <div style={{display: smallMedia ? "none" : "block"}} className='group-az'>
                <div className="group1" >
                <div className="divLogo">
                    <Logo  className="sp-icon"/>
                </div>
                <div className="page-name">
                    <div className="openB"></div>
                    <div className="name-div">
                        <div className="pIconD">
                            <img src={pageIcon} alt="Icon" />
                        </div>
                        <div className="nameD">
                            {pageName}
                        </div>
                    </div>
                    <div className="closeB"></div>
                </div>
                <div className="userDetails" onClick={logoutfnc}>
                        <div className="shadeTriangle-u"></div>
                    <div className="u-pic">
                        <img src={uImg} alt='user' className='sp-icon coverObj' />
                    </div>
                    <div className="u-name">
                        {uName}
                    </div>
                </div>
                </div>
                <div className='logout' style={{display: ulog ? 'block' : 'none'}}>
                <div className='rel-po'>
                <div className='shadeTriangle-rel-po'></div>
                <div className="ulo-pic">
                        <div className='ul-pic'>
                        <img src={uImg} alt='user' className='sp-icon ul-iimg' />
                        </div>
                    </div>
                <div className='admin-name'>
                    {uName} - Admin
                    <div className='mbr-shp'>
                        Member since {uMmbr}
                    </div>
                </div>
                <div className='oL-btn'>
                <div className='shadeTriangle-ot-btn'></div>
                    <button className='out-btn' onClick={signOutFunc}>
                        Sign Out
                    </button>

                </div>
                </div>
                
                </div>
                </div>

            {/* <div className={` ${smallMedia ? "group2sm" : "group2"}`}> */}
            <div className="group2" > 
                <SideBar 
                    onHomeClick={handleHomeClick} 
                    onIngredientsClick={handleIngredientsClick} 
                    onRecipesClick={handleRecipesClick} 
                    onPumpsClick={handlePumpsClick} 
                    onReportsClick={handleReportsClick} 
                    onConfigurationsClick={handleConfigurationsClick}
                />

                <div
                className={`${
                    smallMedia
                    ? "sub-group2sm"
                    : "sub-group2"
                }`}
                style={{ display: home && !mntlyRecSls && !dlySls ? "block" : "none"}}>
                {/* <div className={ `${smallMedia ? "sub-group2sm" : "sub-group2"}`} style={{ display: home && !mntlyRecSls ? 'block' : 'none' }}> */}
                <div className='smCnts'> 
                <Col sm={6} md={3} lg={3}>
                <div className={`small-contair ${smallMedia ? "small-contairsm" : ""}`}>
                <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
                <div className='cntr-txt'>
                {cocktails != null ? cocktails : 0 }
                </div>
                </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Coct className='sp-icon'/>
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cocktail</div>
                    </div>
                </div>
                <div className='empty-div'>
                    <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                            <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                            <button className='trans'>
                                <p className="btnTxt">More info</p>
                                <div className="btn-vec">
                                    <More className='vctr'/>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </Col>
            <Col sm={6} md={3} lg={3}>
            <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt'>
            {currencyDash}{cost != null ? cost.toFixed(2) : 0}
            </div>
            </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                  
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Co className="sp-icon" />
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
                    </div>
                </div>
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More  className='vctr' />
                </div>
                </button>
                </div>
                </div>
                </div>
            </div>
            </Col>
            <Col sm={6} md={3} lg={3}>
            <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t sm-co-t-sp ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt cntr-txt-sp'>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Profit</div><div>{currencyDash} {profit != null ? profit.toFixed(2) : "0.00"}</div> 
                </div>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Margin</div><div>{margin}%</div> 
                </div>                
            </div>
            </div>
                {/* <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                  
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Co className="sp-icon" />
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
                    </div>
                </div>  */}
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More className='vctr'/>
                </div>
                </button>
                </div>
            </div>
            </div>
            </div>
            </Col>
            <Col sm={6} md={3} lg={3}>
            <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt'>
            {currencyDash}{collections != null ? collections.toFixed(2) : 0}
            </div>
            </div>
                <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
                
                    <div className='cntr-txt plFl'>
                    <div className='small-vv'>
                    <Coll className='sp-icon'/>
                    </div>
                    <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`} >Collection</div>
                    </div>
                </div>
                <div className='empty-div'>
                <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
                <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
                <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
                <button className='trans'>
                <p className="btnTxt">More info</p>
                <div className="btn-vec">
                    <More className='vctr'/>
                </div>
                </button>
                </div>
                </div>
                </div>
            </div>
            </Col>
            </div>
            <div className='group2b'>
            <Col sm={12} md={6} lg={6}>
                <div  className={`daily-div ${showDiv ? 'setHeight' : ''} ${smallMedia ? "mrgnR smWi" : ""}`}>
                {/* <div className="border-sales"> */}
                <div className="triangle-container-dr" >
                <div className={` ${smallMedia ? "shadeTriangle-dr2" : "shadeTriangle-dr"}`}></div>
                </div>
                <div className='bDaily mont-sls-cont'>
                <div className='overly-fix' onClick={showDlyRev}></div>
                <div className='bDaily-hdng'>
                    <div className="dr-icon">
                        {/* <img src={drIcon} alt="icon" /> */}
                        <DailyIcon className="icon-sm"/>
                    </div>
                    <div className={`dr-t ${smallMedia ? "dr-t2" : ""}`}>
                        Daily Revenue
                    </div>
                    <div className={`active12a sp-daily-I ${smallMedia ? "active12b" : ""}`} >
                    <div className={`sm-vector ${smallMedia ? "sm-vector2" : ""}`}></div>
                    </div>
                </div>
                </div>
            
                {/* </div> */}
                <div className="daily-r" style={{ width: '100%'}}>
                    <div className={`monthly-s ${smallMedia ? 'monthly-s2' : ''}`} >
                        <div className='mntly-dtls-sls-dsh'>
                            <table className='mntlyTblDtlsDsh'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Sale Count</th>
                                        <th>Revenue</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...dataDly]
                                    .sort((a, b) => Number(b.revenue || 0) - Number(a.revenue || 0))
                                    .map((item, index) => (
                                        <tr key={index}>
                                        <td title={item.name || "N/A"}>
                                            {item.name
                                            ? item.name.length > 15
                                                ? `${item.name.slice(0, 15)}...`
                                                : item.name
                                            : "N/A"}
                                        </td>

                                        <td>{item.sales ? item.sales : "N/A"}</td>

                                        <td>{item.revenue ? item.revenue : "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
                </div>
                </Col>
                <Col sm={12} md={6} lg={6}>
                <div className={`daily-div daily-divb ${showDiv ? 'setHeight' : ''} ${smallMedia ? "mrgnR smWi" : "monthlyDiv"}`}>
                {/* <div className="border-sales"> */}
                <div className="triangle-container-dr" >
                <div className={` ${smallMedia ? "shadeTriangle-dr2" : "shadeTriangle-dr"}`}></div>
                </div>
                <div className='overly-fix' onClick={showMntlySlsRec}></div>
                <div className='bDaily mont-sls-cont'>
                <div className='bDaily-hdng'>
                <div className="mo-s">
                    {/* <img src={moR} alt="icon" /> */}
                    <MonthlyIcon className="icon-sm" />
                </div>
                <div className={`mo-t ${smallMedia ? "mo-t2" : ""}`}>
                    Monthly Sales of Recipe
                </div>
                <div className={`mntly-icn active12a ${smallMedia ? "active12b" : ""}`}>
                <div className={`sm-vector ${smallMedia ? "sm-vector2" : ""}`}></div>
                </div>
                </div>
                </div>

                {/* </div> */}
                
                <div className={`monthly-s ${smallMedia ? 'monthly-s2' : ''}`} >
                    <div className='mntly-dtls-sls-dsh'>
                        <table className='mntlyTblDtlsDsh'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Sale Count</th>
                                    <th>Revenue</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...data]
                                .sort((a, b) => Number(b.revenue || 0) - Number(a.revenue || 0))
                                .map((item, index) => (
                                    <tr key={index}>
                                    <td title={item.name || "N/A"}>
                                        {item.name
                                        ? item.name.length > 15
                                            ? `${item.name.slice(0, 15)}...`
                                            : item.name
                                        : "N/A"}
                                    </td>

                                    <td>{item.sales ? item.sales : "N/A"}</td>

                                    <td>{item.revenue ? item.revenue : "N/A"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
                </Col>
                </div>
            {/* </Row> */}
            <div className='d-table'>
            {/* <Row> */}
            <Col sm={12} md={6} lg={6} >
            <div  className={`stock-con ${smallMedia ? "mrgnR2" : ""}`}>
                <HomeIngredient uId={uId}/>
            </div>
            </Col>
            <div style={{display: smallMedia ? "block" : "none"}} className='empty-tbl'></div>
            <Col sm={12} md={6} lg={6}>
            <div  className={`cl-con ${smallMedia ? "mrgnR" : "monthlyDiv"}`}>
            <CleaningTable uId={uId}/>
            </div>
            </Col>
            {/* </Row> */}
            </div>

            {/* </Container> */}
            {/* </div> */}
        </div>
        <div className={` ${smallMedia ? "sub-group2sm recTblDtlssm" : "sub-group2 recTblDtls"}`} style={{ display: home ? mntlyRecSls ? "block" : "none" :'none' }}>
            <MntlySlsDtls setMntlyRecSls = {setMntlyRecSls} defaultRange="month" />
        </div> 
        <div className={` ${smallMedia ? "sub-group2sm recTblDtlssm" : "sub-group2 recTblDtls"}`} style={{ display: home ? dlySls ? "block" : "none" :'none' }}>
            <MntlySlsDtls setDlySls = {setDlySls} defaultRange="day" />
        </div> 
        <div className={` details-recipes ${smallMedia ? "details-recipes-a" : "details-recipes2"}`} style={{ display: ingredient ? 'block' :'none' }} >
            <IngredientTable  uId={uId}/>
        </div>

        <div style={{display: recipe? "block": "none"}} className={` details-recipes ${smallMedia ? "" : "details-recipes2"}`}>
            <RecipesTable currencyDash={currencyDash} onPageNameChange={handlePageNameChange} ref={childRef} uId={uId}/>
        </div>
        <div style={{display: pumps ? "block" : "none"}} className={` details-recipes ${smallMedia ? "" : "details-recipes2"}`}>
         <PumpsTable uId={uId}/>
        </div>
        <div style={{display: report ? "block" : "none"}} className={` details-reports ${smallMedia ? "" : "details-recipes2"}`}>
            <DatePickercom currencyDash={currencyDash}  uId={uId}/>
            </div>
        <div style={{display: configuration ? "block" : "none"}} className={` details-recipes ${smallMedia ? "" : "details-recipes2"}`}>
            <Configurations setCurrencyDash={setCurrencyDash} />
        </div>
        </div>

        </div> 
    )}
        </>
    )
}
export default DashBoard;
